import { createRoot } from 'react-dom/client';
import 'index.css';
import 'tailwind.css';
import RootNavigator from 'components/navigation/RootNavigator';
import * as serviceWorker from 'serviceWorker';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

// Context
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { theme } from 'context/theme';
import { AuthProvider } from 'context/auth';
import { NotificationProvider } from 'context/notification';
import { DrawerProvider } from 'context/drawer';
import StatusCheck from 'context/statusCheck';
import { ReactQueryProvider } from 'react-query';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const cache = createCache({
    key: 'css',
    prepend: true, // crucial for MUI to override default styles
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <CacheProvider value={cache}>
        <StatusCheck>
            <NotificationProvider>
                <AuthProvider>
                    <ReactQueryProvider>
                        <DrawerProvider>
                            <StyledEngineProvider injectFirst>
                                <ThemeProvider theme={theme}>
                                    <CssBaseline />
                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                        <RootNavigator />
                                    </LocalizationProvider>
                                </ThemeProvider>
                            </StyledEngineProvider>
                        </DrawerProvider>
                    </ReactQueryProvider>
                </AuthProvider>
            </NotificationProvider>
        </StatusCheck>
    </CacheProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
